import React from 'react';
import QrCode from '@components/produkte/QrCode';
import { parseColorGraphic } from '@utils/colorGraphic';

const CardVorschau = ({ bildInfos }) => {
  let farbe;
  let qr;
  let qrFarbe;
  let bild;
  // Defensiv: bildInfos kann fehlen (undefined/null) — z.B. einseitige
  // Designer-Karte ohne Rückseiten-URL. Kein .startsWith auf undefined,
  // sonst crasht der ganze Warenkorb.
  if (typeof bildInfos !== 'string' || !bildInfos) {
    return null;
  }
  const tempBild = parseColorGraphic(bildInfos);
  if (tempBild) {
    farbe = tempBild.Farbe;
    qr = tempBild.QR_Code;
    qrFarbe = tempBild.QR_Code_Farbe;
  } else {
    bild = bildInfos;
  }

  return (
    <div className="aspect-[1.586/1] sm:mb-0 mb-6">
      {bild ? (
        <img
          src={bild}
          alt="sVisit Custom Karte"
          className="h-full w-full flex-none rounded-lg object-cover"
        />
      ) : (
        <div
          className="h-full w-full flex-none rounded-lg grid place-items-center"
          style={{ backgroundColor: farbe }}
        >
          <div className="w-1/3">{qr ? <QrCode color={qrFarbe} /> : ''}</div>
        </div>
      )}
    </div>
  );
};

export default CardVorschau;
